import { Component, Input, OnInit } from '@angular/core';
import { ItemRss } from 'app/shared/models/itemRss/itemRss';
import { DataService } from 'app/shared/services/data/data.service';

@Component({
  selector: 'app-item-flux-rss',
  templateUrl: './item-flux-rss.component.html',
  styleUrls: ['./item-flux-rss.component.scss']
})
export class ItemFluxRssComponent implements OnInit {
  @Input() item: ItemRss;

  constructor(
    private dataService: DataService,
  ) { }

  ngOnInit(): void {
  }

  keyword(event): void {
    const inputvalue = event.target.innerText;
    const keyword = inputvalue.toLowerCase();
    this.dataService.keyword.next(keyword);
  }

}
